module.exports = __webpack_public_path__ + "img/chess.b6c35aea.jpg";